import { BACKEND_URL } from "@/lib/constants/constants";
import type { ParsedAccountRecord } from "../gql/types";
import axios from "./axiosConfig";

export const companySetupApi = {
  createTenant: async (tenantData: any) => {
    const response = await axios.post(
      `${BACKEND_URL}/api/create-tenant`,
      tenantData,
    );
    return response.data;
  },

  generateCompanyDescription: async (
    data: {
      companyName: string;
      address: any;
    },
    signal?: AbortSignal,
  ): Promise<{ companyDescription: string; annotations: any[] }> => {
    const response = await axios.post(
      `${BACKEND_URL}/api/generate-company-description`,
      data,
      {
        signal,
      },
    );
    return response.data;
  },

  createCompanySelfService: async (tenantData: any) => {
    const response = await axios.post(
      `${BACKEND_URL}/api/companies/self-service`,
      tenantData,
    );
    return response.data;
  },

  checkCompanySlug: async (params: { name?: string; slug?: string }) => {
    const response = await axios.get(
      `${BACKEND_URL}/api/companies/check-slug`,
      {
        params,
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data as { exists: boolean; slug: string };
  },

  giveAccess: async (accessData: any) => {
    const response = await axios.post(
      `${BACKEND_URL}/api/give-access`,
      accessData,
    );
    return response.data;
  },

  uploadSuppliers: async (formData: FormData) => {
    const response = await axios.post(
      `${BACKEND_URL}/api/suppliers/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  },

  uploadAccounts: async (formData: FormData) => {
    const response = await axios.post(
      `${BACKEND_URL}/api/accounts/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  },
  uploadCostCenters: async (formData: FormData) => {
    const response = await axios.post(
      `${BACKEND_URL}/api/cost-centers/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  },

  createAccounts: async (accountsData: {
    accounts: ParsedAccountRecord[];
    accountLength: 4 | 5 | 6;
  }) => {
    const response = await axios.post(
      `${BACKEND_URL}/api/admin-create-accounts`,
      accountsData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  },

  getCompanyStatus: async () => {
    const response = await axios.get(`${BACKEND_URL}/api/companies/status`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  },

  updateCompanyStatus: async (payload: { status: "active" | "pending" }) => {
    const response = await axios.put(
      `${BACKEND_URL}/api/companies/status`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  },
};
